import CancellableHelper from "@/requests/CancellableHelper";
import { AttributePrototypeDetailed, AttributePrototypesList } from "@/models/api/Attributes";

//#region Routes
export const URL_GET_ATTRIBUTE_PROTOTYPES = "/Attribute/Prototype";
export const URL_GET_ATTRIBUTE_PROTOTYPE = "/Attribute/Prototype/${AttributePrototypeId}";
//#endregion

const _getAttributePrototypes = new CancellableHelper<AttributePrototypesList>(
  URL_GET_ATTRIBUTE_PROTOTYPES,
  AttributePrototypeDetailed
);
export const getAttributePrototypes = async (): Promise<AttributePrototypesList> => {
  return await _getAttributePrototypes.get();
};

const _getAttributePrototype = new CancellableHelper<AttributePrototypeDetailed>(
  URL_GET_ATTRIBUTE_PROTOTYPE,
  AttributePrototypeDetailed
);
export const getAttributePrototype = async (attributePrototypeId: number): Promise<AttributePrototypeDetailed> => {
  return await _getAttributePrototype.get({ AttributePrototypeId: attributePrototypeId });
};
